import {configureStore} from '@reduxjs/toolkit';
import appDataSlice from './appDataSlice';

const store = configureStore({
  reducer: {apiData: appDataSlice},
});

export default store;
